import { useMediaQuery } from '@mui/material'
import { emotionTheme } from '@styles/theme'

import { currencyMask } from '@utils/masks/currencyMask'
import { RowBox } from '@components/shared/RowBox'

import type { RowTableTotalProps } from './types'

import * as S from './styles'

export const RowTableTotal = ({ data }: RowTableTotalProps) => {
  const isMobile = useMediaQuery(`(max-width: ${emotionTheme.screenSizes.laptop})`)

  return (
    <RowBox columns={data.length} gap={0}>
      {data.map((item, index) => (
        <S.Footerlabel
          key={item.label}
          style={{
            borderLeft: isMobile ? 'none' : !!index ? `1px solid ${emotionTheme.colors.border.light}` : 'none',
            borderBottom: isMobile
              ? index !== data.length - 1
                ? `1px solid ${emotionTheme.colors.border.light}`
                : 'none'
              : 'none'
          }}
        >
          {item.label}:<S.FooterValue>{currencyMask(item.value.toFixed(2))}</S.FooterValue>
        </S.Footerlabel>
      ))}
    </RowBox>
  )
}
